export default __webpack_public_path__ + "static/media/main_logo_yellow.ca5e86d6.png";